import { Route, Routes } from 'react-router-dom';
import './App.css';
import Dashboard from './screens/dashboard/Dashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cources from './screens/Cources';
import Teachers from './screens/teachers';
import CourcesDetails from './screens/Cources/CourcesDetails';
import StudentDashboard from './screens/StudentPanel/dashboard/StudentDashboard';
import MyCources from './screens/StudentPanel/mycourses/MyCourses';
import StudentCourceDetails from './screens/StudentPanel/courceDetails/CourceDetails';
import DoctorDashboard from './screens/TeacherPanel/DoctorDashboard';
import DoctorCources from './screens/TeacherPanel/DoctorCources';
import DoctorCourcesDetails from './screens/TeacherPanel/CourceDetails';
import Attendance from './screens/TeacherPanel/Attendance';
import StudentDetails from './screens/StudentDetails';
import AdminLogin from './screens/Login';
import ProtectedRoute from './components/Routing/ProtectedRoute';
import { Navigate } from 'react-router-dom';
import EnrolledCourseDetails from './screens/StudentPanel/courceDetails/EnrolledCourceDetails';
import Settings from './screens/Settings';
import JobApplications from './screens/JobApplications';
import ContactRequests from './screens/ContactRequests';
import Fees from './screens/Fee/Fees';
import AdminAttendance from './screens/Attendance/AdminAttendance';
import TeacherStudents from './screens/teachers/TeacherStudents';
import TeacherSettings from './screens/TeacherPanel/TeacherSettings';
import StudentSettings from './screens/StudentPanel/StudentSettings';
import Documents from './screens/StudentPanel/Documents';
import Gallery from './screens/Gallery';
import Completed from './screens/Completed/Completed';
import SingleCourceDetails from './screens/TeacherPanel/SingleCourceDetails';
import EnrollStudentsDetails from './screens/Fee/EnrollStudentsDetails';
import StudentFeeAttendance from './screens/Fee/StudentFeeAttendance';
import AdmissionRequest from './screens/AdmissionRequest';

function App() {
  const isLoggedIn = window.localStorage.getItem('loggedIn');
  const userType = window.localStorage.getItem('role');
  return (
    <>
      <ToastContainer />
      <Routes>
        {!isLoggedIn && (
          <>
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/" element={<AdminLogin />} />
            <Route path="*" element={<AdminLogin />} /> {/* Catch-all route */}
          </>
        )}

        <Route element={<ProtectedRoute />}>
          <Route path="/login" element={<Navigate to="/" />} />

          {userType === 'admin' ? (
            <>
              <Route path="/" element={<Dashboard />} />
              <Route path="/cources" element={<Cources />} />
              <Route path="/cources-details/:id" element={<CourcesDetails />} />
              <Route path="/student-details/:id/:email" element={<StudentDetails />} />
              <Route path="/teachers" element={<Teachers />} />
              <Route path="/job-applications" element={<JobApplications />} />
              <Route path="/contact-requests" element={<ContactRequests />} />
              <Route path="/fees" element={<Fees />} />
              <Route path="/enroll-student-details/:id/:email" element={<EnrollStudentsDetails />} />
              <Route path="/student-fee-attendance/:id/:id2/:id3/:name" element={<StudentFeeAttendance />} />
              <Route path="/admin-completed-course" element={<Completed />} />
              <Route path="/teacher-student/:id" element={<TeacherStudents />} />
              <Route path="/admin-attendance" element={<AdminAttendance />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admission-request" element={<AdmissionRequest />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : userType === 'student' ? (
            <>
              <Route path="/" element={<StudentDashboard />} />
              <Route path="/my-cources" element={<MyCources />} />
              <Route path="/student-settings" element={<StudentSettings />} />
              <Route path="/documents/:id" element={<Documents />} />
              <Route path="/cource-details/:id" element={<StudentCourceDetails />} />
              <Route path="/enrolled-cource-details/:id" element={<EnrolledCourseDetails />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : userType === 'teacher' ? (
            <>
              <Route path="/" element={<DoctorDashboard />} />
              <Route path="/teacher-cources" element={<DoctorCources />} />
              <Route path="/teacher-cource-details/:id" element={<DoctorCourcesDetails />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/single-cources-details/:id" element={<SingleCourceDetails />} />
              <Route path="/teacher-settings" element={<TeacherSettings />} />
              <Route path="*" element={<Navigate to="/" />} />
              {/* <Route path="*" element={<Navigate to="/" />} /> */}
            </>
          ) : null}
        </Route>
      </Routes>
    </>
  );
}

export default App;
